export enum ApplicationMethod {
    GlobalApplicationForm = 'Partner Portal',
    DirectEntryWaiver = 'Direct Entry Waiver',
}